<template>
  <div class="receive-record">
    <div class="null" v-if="list.length == 0">
      <img
        class="null-icon"
        src="https://hopemall.oss-cn-hangzhou.aliyuncs.com/suixintao/recordNull.png"
      />
      <div class="null-msg">暂无领取记录~</div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      loading-text="正在加载..."
    >
      <div class="box" v-for="(item, index) in list" :key="index">
        <div class="box-top">
          <div class="title">
            <img :src="item.item_small_icon" />
            <span class="name">{{ item.item_name }}</span>
          </div>
          <div class="more" @click="showExplain(item.item_name)">
            <span class="text">使用说明</span>
            <img
              src="https://cdn.qiumo.net.cn/allsmarketmaterial/receive_zhengxing/icon_more.png"
            />
          </div>
        </div>
        <div class="box-cont">
          <div class="line">领取号码：{{ item.phone_number }}</div>
          <div class="line">领取时间：{{ item.exchange_time }}</div>
          <!-- <div class="line">
          兑换码：GHDLJFLJG<span class="border" /><span class="copy">复制</span>
        </div> -->
        </div>
      </div>
    </van-list>
    <v-alert
      :visibility.sync="alert.visibility"
      :title="alert.title"
      :message="alert.message"
    />
  </div>
</template>

<script>
import VAlert from "./dialog/alert.vue";
import { record } from "@/api/carOwner_zhengxing/receive.js";
import { mapGetters } from "vuex";

export default {
  components: {
    VAlert,
  },
  data() {
    return {
      list: [],
      alert: {
        visibility: false,
        title: "",
        message: "",
      },
      loading: false, // 控制加载状态
      finished: false, // 是否已全部加载完毕
      page: 0, // 当前页数，默认从第1页开始
      // pageSize: 20, // 每页显示的数据条数
    };
  },
  computed: {
    ...mapGetters(["carOwner_zhengxing_token"]),
  },
  created() {
    // this.getList();
  },
  methods: {
    async onLoad() {
      this.loading = true;

      try {
        this.page++; // 更新当前页数，准备请求下一页数据
        const res = await this.getList();
        this.list = [...this.list, ...res.record];
        // 检查是否有更多数据，可以根据 res 中的 meta 或者其他字段判断
        if (this.page == res.pages) {
          // 加载完毕
          this.finished = true;
        } else {
          this.finished = false;
        }
      } catch (error) {
        // console.error("加载失败:", error);
        this.$router.replace("/carOwner_zhengxing/receive/login");
      } finally {
        this.loading = false;
      }
    },
    async getList() {
      try {
        const res = await record(this.carOwner_zhengxing_token, {
          page: this.page,
          data_type: "exchange",
        });
        return res;
      } catch (error) {
        this.finished = true;
      }
    },
    showExplain(name) {
      const data = {
        车主通用券: `1.本红包仅支持支付宝车生活相关的加油、充电、高速
MTC、停车场景，以及支付宝代驾小程序、支付宝租车小程序、支付宝洗车小程序、ETC服务小程序使用。车主红包具体支持核销场景及核销规则如下：
(1)加油：本红包油卡支付不可用。红包使用范围：用户可在支付宝首页【出行-车生活-加油】展示的油站完成一键加油或选择对应油枪的线上订单，并选择支付宝在线支付时使用。
(2)充电：红包仅限在支付宝-首页【出行】-【车生活】-【充电】展示的充电品牌充电站使用，仅适用于汽车充电订单。
(3)高速MTC:红包仅限在走高速人工通道缴过路费时【使用支付宝支付】可用。
(4)停车：1.用户进入【支付宝停车】小程序，输入车牌号查询缴费，支付时自动抵扣；2.支持全国支付宝缴费停车场支付使用(可至支付宝APP-“附近停车”小程序-推荐停车场查看停车场分布);
(5)代驾：1.打开支付宝首页【出行-车生活-代驾】,下单呼叫代驾，完成订单支付时直接抵扣；2.在支付宝首页搜索“支付宝代驾”,点击进入【支付宝代驾】服务，下单呼叫代驾，完成订单支付时直接抵扣；
(6)租车：用户可在【支付宝租车】小程序中选择展示红包优惠的车辆使用，仅限年满18周岁拥有驾照的用户租车使用。
(7)洗车：1.打开支付宝首页【出行-车生活-特价洗
车】,下单使用；2.在支付宝首页搜索“支付宝特价洗车”,点击进入【支付宝特价洗车】服务，下单使用；
(8)ETC:仅限在支付宝小程序「ETC服务」办理客车ETC套餐使用(不包含建行免费款)。支付客车ETC办理费用时自动抵扣。
2.红包在交易时支持叠加使用，最多叠加10个。本红包不可兑换现金，不可找零。

3.权益使用有效期自领取之时起至30*24h。若使用红包的交易发生退款，红包将退回到原支付宝账号，使用有效期不变，退还红包在原有效期内可继续使用；如在原有效期外，则红包失效，不支持再次使用。
4.本红包仅限在中国大陆地区使用。本红包限实名认证用户才可使用。
5.如对本活动有疑问的，可通过官方热线4001180238进行咨询。
6.如果用户存在或涉嫌违法违规行为情况(包括不限于洗钱、虚假交易、作弊、套现、赌博、刷信用、支付宝基于自身风险政策或策略认定的风险交易等)的，支付宝将撤销用户活动参与资格和奖品使用资格，并有权回收用户已经获得的奖励权益(包括已消费金额)。请特别关注：淘宝集市购买Q币点卡、影视会员业务、游戏视频网站的一键支付业务、无卡支付业务、货到付款业务、外部商户独立担保交易等业务无法使用红包支付。
7.活动主办方可能需要根据活动的实际举办情况对活动规则依法进行变更；若有变更，活动主办方将以活动页面告知等方式及时通知；
8.本活动开展期间，如出现不可抗力等情况，例如发生自然灾害事件、遭受网络攻击或电信故障、停机维护、
疫情、活动受法律法规、监管机构要求或政策指令需要LII停止举办或调整，活动主办方单方暂停、中止或终止提供服务的，可免于承担责任。请特别关注：淘宝集市购买Q币点卡、影视会员业务、游戏视频网站的一键支付业
务、无卡支付业务、货到付款业务、外部商户独立担保交易等业务无法使用红包支付!`,
        滴滴代驾: `1.代驾券仅限滴滴出行 APP 或微信客户端内代驾业务线上支付时使用(代驾券不可抵扣司机报单订单、路桥费、纯等候费)
2.代驾券仅限在滴滴出行-代驾业务开通的城市使用。
3.代金券充值自领取之日起有 30 天的有效，过期不退不换:滴滴订单时间需在券到账时间之后方可用，券到账前已经开始的订单无法使用
4.只能用于支付券码到帐滴滴钱包后发起的滴滴订单，在领取券码前已发起的订单无法支付`,
        滴滴打车券: `1.本品为滴滴出行快车代金券直充，仅支持账号绑定手机号码充值。请用户在充值前确保号码已开通滴滴账号。
2.虚拟商品，一经提交充值不支持退换。
3.一笔订单只能使用一张优惠券，并且只能抵扣充值到账户之后的生成的订单，优惠券不拆分、不找零，请合理选择是否使用优惠券，优惠不足部分需用电子支付方式补足。拼车、特惠快车无法使用。
4.到账后有效期30天，请及时使用`,
        滴滴专车券: `1.本品为滴滴出行专车代金券直充，仅支持账号绑定手机号码充值。
2.虚拟商品，一经提交充值不支持退换。
3.一笔订单只能使用一张优惠券，并且只能抵扣充值到账户之后生成的订单，优惠券不拆分、不找零，请合理选择是否使用优惠券。
优惠券选券排序
① 优先选可抵扣金额最大的
② 可抵扣金额一样的情况下，选未用尽金额更小的
③ 可抵扣金额一样，未用尽金额 一样，选择过期时间更近的
4.到账后有效期30天，请及时使用`,
        高德打车: `高德打车
1.注册高德的手机号提交充值，本券仅限在高德地图中使用。
2.仅限在高德地图端内打车时使用，出租车、一口价订单不能使用。
3.打车券有效期为充值成功之日起7天内有效，请在券有效期内使用，过期失效作废。
4.同一订单优惠券最多可使用一张，不可叠加使用;券仅限一次性使用，不可拆分，不可转让，不可提现。
5.充值成功后，登录[高德地图] app，点击[我的]-[钱包卡券]-[券]处查看使用规则及有效期情况。
6.对券的使用等有任何疑问可以拨打客服电话: 4001180238
7.到账后有效期7天，请及时使用`,
      };
      this.alert = {
        visibility: true,
        title: `${name}`,
        message: data[name],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.receive-record {
  padding: 50px 0 100px;
  .null {
    text-align: center;
    padding-top: 206px;

    &-icon {
      display: block;
      margin: 0 auto;
      width: 139px;
      height: 157px;
    }

    &-msg {
      padding-top: 37px;
      font-size: 28px;
      color: #af3e51;
    }
  }
  .box {
    // height: 266px;
    background: #ffffff;
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    margin: 0 32px 30px;
    padding: 24px 30px 30px;
    box-sizing: border-box;

    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 20px;

      .title {
        img {
          width: 69px;
          padding-right: 24px;
        }
        .name {
          font-weight: 400;
          font-size: 34px;
          line-height: 48px;
        }
      }

      .more {
        .text {
          font-weight: 400;
          font-size: 26px;
          color: #999999;
          line-height: 37px;
        }

        img {
          width: 28px;
          padding-left: 6px;
        }
      }
    }

    &-cont {
      .line {
        font-weight: 400;
        font-size: 26px;
        color: #999999;
        line-height: 37px;
        padding-bottom: 6px;
        display: flex;
        align-items: center;

        .copy {
          color: #4ea9fd;
        }

        .border {
          display: inline-block;
          width: 2px;

          height: 26px;
          background-color: #999999;
          margin: 0 11px 0 15px;
        }
      }
    }
  }
}
</style>
